import { render, staticRenderFns } from "./BankStatementReader.vue?vue&type=template&id=499a2056&scoped=true&"
import script from "./BankStatementReader.vue?vue&type=script&lang=js&"
export * from "./BankStatementReader.vue?vue&type=script&lang=js&"
import style0 from "./BankStatementReader.vue?vue&type=style&index=0&id=499a2056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a2056",
  null
  
)

export default component.exports